import React from 'react';
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from "@mui/material/Button";
import awsAuthSignIn from '../../components/AwsService/aws-auth-signin';
import { toast } from "react-toastify";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import wait from '../reports/loader/wait.svg';
// import moment from "moment";
//import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
//import Radio from '@mui/material/Radio';
//import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
import EventTypeEnum from './event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EVENT_TYPES from '../common/event-type';
import ASSIGNSTATUS from '../assign-prescriptions/assignment-status';
import { States } from '../common/states';
//import Selector from '../select';
//import FormHelperText from "@mui/material/FormHelperText";

import { w3cwebsocket as W3CWebSocket } from "websocket";
import Table from '@mui/material/Table';
import { emitRealtimeEvent } from '../../utils/realtimeEventEmitter';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classNames from 'classnames';
import Checkbox from "@mui/material/Checkbox";
import TextareaAutosize from 'react-autosize-textarea';
import DialogContentText from "@mui/material/DialogContentText";
import { withTranslation } from 'react-i18next';

const DISABLE_WEBSOCKET = true;
const client = DISABLE_WEBSOCKET ? null : new W3CWebSocket('wss://dev.socket.localbox.net/');
function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    width: "100%"
  },
  waitIcon: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    zIndex: '99999999'
    // opacity: 0.5
  },
  imgProperty: {
    height: '100px'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  },
  tabtitle: {
    fontSize: '1.3125rem',
    lineHeight: '16667em',
    fontWeight: 500
  },
  flex: {
    color: 'black',
    fontWeight: 500
  }
});

class PatientManulOverride extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DialogOpen: this.props.detailDialogOpen,
      selectedTab: 0,
      whoPickup: 'none',
      isUserValidate: false,
      readOnlyPwd: false,
      allowWait: false,
      isButtonDisabled: false,
      stateToChange: '',
      user: {
        p_DriversLicenseNo: '',
        p_first_name: '',
        p_last_name: '',
        p_email: '',
        phone: null,
        password: '',
        p_relation: 'Patient'
      },
      StatesValues: [],
      selectedStateCode: "",
      hasStateCodeError: false,
      PatietPrescriptionData: '',
      consultnotes: '',
      ReleaseOrder: false,
      ReleaseOrderOpen: false,
      orderNotReleasedOpen: false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.handleOpenBin = this.handleOpenBin.bind(this);
  }
  componentWillMount() {
    this.clientConnectWithWebsocket();
    const stateValues = States.states.map(s => {
      return { value: s.abbreviation, label: s.name };
    });
    this.setState({ StatesValues: stateValues });
    this.getPrescriptionDetailByPickupCode(this.props.selectedObject.pucode);
    this.getManualReleaseOrderDetailByPickupCode(this.props.selectedObject.pucode);
  }
  clientConnectWithWebsocket() {
    if (DISABLE_WEBSOCKET) return;
    client.onopen = () => {
      console.log('WebSocket Client Connected');
    };
    client.onmessage = (message) => {
      const dataFromServer = JSON.parse(message.data);
      let boxdetail =
        dataFromServer &&
        dataFromServer.data &&
        dataFromServer.data.users &&
        dataFromServer.data.users[this.props.selectedObject.kiosk_box_id.toUpperCase()];

      const stateToChange = {};
      if (dataFromServer.type === "PORTAL") {
        // stateToChange.currentUsers = Object.values(dataFromServer.data.users);
        if (boxdetail !== undefined && boxdetail !== 'undefined') {
          if (boxdetail.command === 'OPEN-BIN-SUCCESS') {
            toast.success(this.props.t('Toast.Success.OpenBin'));
            this.setState({ allowWait: false, isButtonDisabled: false });
          }
        }
      } else if (dataFromServer.type === "KIOSK") {
        // stateToChange.text = dataFromServer.data.editorContent || contentDefaultMessage;
        if (boxdetail !== undefined && boxdetail !== 'undefined') {
          if (boxdetail.command === 'OPEN-BIN-SUCCESS') {
            toast.success(this.props.t('Toast.Success.OpenBin'));
            this.setState({ allowWait: false, isButtonDisabled: false });
          }
        }
      }
      else {
        this.setState({ allowWait: false, isButtonDisabled: false });
      }
      // stateToChange.userActivity = dataFromServer.data.userActivity;
      this.setState({ stateToChange: stateToChange });
    };
    client.onerror = () => {
      console.log(`Client error`);
      this.setState({ allowWait: false, isButtonDisabled: false });
    }
    client.onclose = () => {
      console.log(`connection closed`);
      this.setState({ allowWait: false, isButtonDisabled: false });
    }
  }
  handleTabChange = (event, index) => {
    this.setState({ selectedTab: index });
  };
  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  };
  handleClose = () => {
    this.setState({ DialogOpen: false, isUserValidate: false, orderNotReleasedOpen: false });
    this.props.onPopupClose();
  }
  onPasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }
  handleValidate = async event => {
    event.preventDefault();
    if (this.state.selectedStateCode === "") {
      this.setState({ hasStateCodeError: true });
      return;
    }
    this.setState({ isButtonDisabled: true, allowWait: true });
    if (this.state && this.state.isUserValidate === false) {
      let userObj = { username: '', password: this.state && this.state.user.password ? this.state.user.password : '' };
      let res = await awsAuthSignIn(userObj);
      if (res && res.status === 200) {
        toast.success(res.instruction);
        this.saveCustomerCollectedDetail();
        this.setState({ isUserValidate: true, allowWait: false, readOnlyPwd: true, isButtonDisabled: false, whoPickup: 'block' })
      }
      else {
        toast.error(res.instruction);
        this.setState({ allowWait: false, readOnlyPwd: false, isButtonDisabled: false });
      }
    }
    else {
      toast.error(this.props.t('Toast.Error.Sorry'));
      this.setState({ allowWait: false, readOnlyPwd: false, isButtonDisabled: false });
    }
  }
  handleOpenBin = event => {
    event.preventDefault();
    if (this.props.selectedObject.kiosk_box_id !== null && this.props.selectedObject.kiosk_box_id !== 'null'
      && this.props.selectedObject.kiosk_box_id !== "" && this.props.selectedObject.kiosk_box_id !== undefined
      && this.props.selectedObject.kiosk_box_id !== 'undefined') {
      this.setState({ isButtonDisabled: true, allowWait: true });
      if (this.state && this.state.isUserValidate === true) {
        // const box_name = this.props.selectedObject.box;
        const bin = this.props.selectedObject.binid;
        const box_id = this.props.selectedObject.kiosk_box_id.toUpperCase();
        // const pm_id=this.props.selectedObject.pmid;
        const command = 'OPEN-BIN';
        if (box_id.trim()) {
          const data = {
            command,
            bin,
            box_id
          };
          this.setState({
            ...data
          }, () => {
            if (!DISABLE_WEBSOCKET) {
              client.send(JSON.stringify({
                ...data,
                type: "PORTAL"
              }));
            }
            this.setState({ isButtonDisabled: true, allowWait: false });
          });
        }
      }
      else {
        toast.error(this.props.t('Toast.Error.Sorry'));
        this.setState({ allowWait: false, isButtonDisabled: false });
      }
    }
    else {
      toast.error(this.props.t('Toast.Error.BoxIdNotConfigure'));
      this.setState({ allowWait: false, isButtonDisabled: false });
    }
  }
  handleChange = event => {
    if (event.preventDefault)
      event.preventDefault();
    const { user } = this.state;
    user[event.target.name || event.target.id] = event.target.value;
    this.setState({ user });
  };
  handleStateChange = event => {
    this.setState({ selectedStateCode: event.target.value });
    if (event.target.value === "") {
      this.setState({ hasStateCodeError: true });
    }
    else {
      this.setState({ hasStateCodeError: false });
    }
  };
  renderLoader() {
    // const { classes } = this.props;
    const loader =
      <div>
        <img
          src={wait}
          alt="Processing"
        />
      </div>
    return loader;
  }
  saveCustomerCollectedDetail() {
    this.setState({ allowWait: true });
    let orderIds = [];
    orderIds.push({ id: this.props.selectedObject.pmid });
    const event_params = {
      event_name: EVENT_CRUD_TYPES.UPDATE,
      event_type_name: EVENT_TYPES.MANUAL_OVERRIDE,
      description: 'Prescription is menual picked up with pick up code ' + this.props.selectedObject.pucode,
      object_id: ASSIGNSTATUS.PICKED_UP,
      tofor_id: this.props.selectedObject.pmid,
      box_id: this.props.selectedObject.boxid,
      authorization: JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
      orderIds: orderIds
    };
    const pickupConfig = {
      firstName: this.props.selectedObject.firstname,
      lastName: this.props.selectedObject.lastname,
      emailId: this.props.selectedObject.email,
      companyLogo: '',
      companyName: '',
      companyContact: '',
      adressLine1: '',
      adressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      orderHtml: '',
      orderLocation: '',
      boxName: this.props.selectedObject.box,
      boxAddress: '',
      pharmAddress: {
        picture_url: 'https://s3.amazonaws.com/rpx-dev-ext-images-qr/NoImageFound.png',
        companyName: this.props.selectedObject.store,
        adressLine1: '',
        adressLine2: '',
        city: '',
        state: '',
        zipcode: '',
        companyContact: ''
      },
      qrCode: '',
      pickupCode: this.props.selectedObject.pucode,
      isDisplay: 'none',
      orders: [
        {
          orderId: '',
          pickupCode: '',
          items: []
        }
      ]
    };
    let formData = {
      customer_id: this.props.selectedObject.customer_id,
      order_id: this.props.selectedObject.pmid,
      picture_url: null,
      signature_url: null,
      drivers_license_no: this.state.user.p_DriversLicenseNo,
      first_name: this.state.user.p_first_name,
      middle_name: null,
      last_name: this.state.user.p_last_name,
      dob: null,
      relationship: this.state.user.p_relation,
      box_id: this.props.selectedObject.boxid,
      account_id: this.props.selectedObject.accid,
      orderIds: orderIds,
      MANUAL_OVERRIDE: EventTypeEnum.MANUAL_OVERRIDE,
      event_params: event_params,
      email_data: pickupConfig,
      type_id: ASSIGNSTATUS.PICKED_UP,
      selectedStateCode: this.state.selectedStateCode,
      dlrawdata: null
    };
    fetch(process.env.REACT_APP_BASEURL + 'savePatientManualOverrideDetail', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)

    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        this.setState({ allowWait: false });
        if (uData && uData.status !== undefined && uData.status === 'Error') {
          toast.error(uData.message);
        }
      });
  }
  getPrescriptionDetailByPickupCode = (pickupcode) => {
    fetch(process.env.REACT_APP_BASEURL + 'getprescriptiondetailbypucode/' + pickupcode, {
      method: "GET",
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession
            .idToken.jwtToken,
      },
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(pData => {
        if (pData) {
          let data = JSON.parse(pData);
          this.setState({ PatietPrescriptionData: data })
        }
      });
  }
  createRow = () => {
    const { classes } = this.props;
    let Data = this.state && this.state.PatietPrescriptionData;
    if (Data) {
      return (Data.map((val, idx) => {
        return (<TableRow>
          <TableCell className={classNames(classes.removePadding)} style={{ padding: '7px 6px 7px 5px', fontSize: '11px' }}>
            {val.rx_no}
          </TableCell>
          <TableCell className={classNames(classes.removePadding)} style={{ padding: '7px 6px 7px 5px', fontSize: '11px' }}>
            {val.drug_name}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: '7px 6px 7px 5px', fontSize: '11px' }}>
            {val.doseage_form}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: '7px 6px 7px 5px', fontSize: '11px' }}>
            {val.qty}
          </TableCell>
        </TableRow>)
      }))
    }
  }
  handleChangeConsultNotes = event => {
    event.preventDefault && event.preventDefault();
    this.setState({ consultnotes: event.target.value });
  };
  handleReleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: true });
  };
  releaseorderaccept = () => {
    this.savemanualuserConsult(true);
  };
  handleCloseRleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: false });
  };
  handleConsultClose = () => {
    this.setState({ orderNotReleasedOpen: false });
  };
  savemanualuserConsult = (releaseOrder = this.state.ReleaseOrder) => {
    var statusObj = {
      consult_start_date: new Date(),
      consult_end_date: new Date(),
      pickup_code: this.props.selectedObject.pucode,
      user_name: this.props.selectedObject.name,
      call_duration: '00:00:00',
      user_id: null,
      consultation_name: this.props.selectedObject.username,
      Status: 'Offline',
      accounts_id: this.props.selectedObject.accid,
      store_name: this.props.selectedObject.store,
      box_id: this.props.selectedObject.boxid,
      kiosk_name: this.props.selectedObject.box,
      consultation_notes: this.state.consultnotes,
      is_releaseorder: releaseOrder
    }
    fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json', Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession
            .idToken.jwtToken
      },
      body: JSON.stringify(statusObj)
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        this.setState({
          ReleaseOrder: releaseOrder,
          ReleaseOrderOpen: false,
          orderNotReleasedOpen: false,
        });
        if (releaseOrder) {
          emitRealtimeEvent(
            'isOrderReleasedFromDeliveryPrescription',
            this.props.selectedObject.pucode
          );
          toast.success(this.props.t('Toast.Success.OrderReleased'));
        } else {
          toast.success(this.props.t('Toast.Success.ConsultComplete'));
        }
        this.handleClose();
      });
  };
  getManualReleaseOrderDetailByPickupCode = (pickupcode) => {
    fetch(process.env.REACT_APP_BASEURL + 'getmanualreleaseorderdetailbypickupcode/' + pickupcode, {
      method: "GET",
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession
            .idToken.jwtToken,
      },
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(pData => {
        if (pData) {
          let data = JSON.parse(pData);
          let item = Array.isArray(data) ? data[0] : data;
          if (item) {
            this.setState({ ReleaseOrder: item.is_releaseorder });
            this.setState({ consultnotes: item.consultation_notes });
          }
        }
      });
  }
  render() {
    const { classes, theme, t } = this.props;
    return (
      <div>
        <Dialog
          open={this.state.DialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'md'}
        >
          <AppBar style={{ maxWidth: '1025px' }} position="static" color="default">
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant={null}
            >
              <Tab label={t("Report.Schedule.PatientDetail.PatientDetailsTitle")} />
              <Tab label={t("Report.Schedule.Box.BoxDetailTitle")} />
              <Tab label={t("Report.Schedule.ConsultTitle")} />
            </Tabs>
          </AppBar>
          <SwipeableViews style={{ maxWidth: '1025px' }}
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.selectedTab}
            onChangeIndex={() => this.handleChangeIndex}
          >
            <TabContainer dir={theme.direction}>
              <div className={classes.paddedBoxDivEdit}>

                <DialogTitle id="form-dialog-title">{t("Report.Schedule.PatientDetail.PatientDetailsText")}</DialogTitle>
                <DialogContent>
                  <Grid container item xs={12}>
                    <Grid item xs={4}>
                      <TextField
                        id="name"
                        label={t("Report.Schedule.PatientDetail.Name")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.name}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '27ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="dob"
                        label={t("Report.Schedule.PatientDetail.DOB")}
                        className={classes.textField}
                        margin="normal"
                        value={(this.props.selectedObject.dob_str !== null && this.props.selectedObject.dob_str !== 'null' && this.props.selectedObject.dob_str !== undefined && this.props.selectedObject.dob_str !== 'undefined') ? this.props.selectedObject.dob_str : ''}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: ' 33ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={4}>
                      <TextField
                        id="phone"
                        label={t("Report.Schedule.PatientDetail.Phone")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.phone}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: ' 27ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="email"
                        label={t("Report.Schedule.PatientDetail.Email")}
                        className={classes.textField}
                        margin="normal"
                        style={{ width: '300px' }}
                        value={this.props.selectedObject.email}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: ' 27ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary" className={classes.primaryButton} style={{ position: 'absolute', bottom: '15px' }}>
                    {t("Report.Schedule.PatientDetail.CloseButton")}
                  </Button>
                </DialogActions>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <DialogTitle id="form-dialog-title">{t("Report.Schedule.Box.BoxDetailText")}</DialogTitle>
                <DialogContent>
                  <Grid container item xs={12}>
                    <Grid item xs={4}>
                      <TextField
                        id="boxname"
                        label={t("Report.Schedule.Box.BoxName")}
                        className={classes.textField}
                        margin="normal"
                        sx={{ width: '27ch' }}
                        value={this.props.selectedObject.box}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="box_type"
                        label={t("Report.Schedule.Box.BoxType")}
                        className={classes.textField}
                        margin="normal"
                        sx={{ width: '27ch' }}
                        value={this.props.selectedObject.box_type}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="bin"
                        label={t("Report.Schedule.Box.BIN")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.binid}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '27ch' }}
                      />
                    </Grid>
                  </Grid>
                  <Typography variant="title" style={{ paddingTop: "20px", fontSize: '1.2125rem', fontWeight: 500 }}>
                    {t("Report.Schedule.Box.BoxAddress")}
                  </Typography>
                  <Grid container item xs={12}>
                    <Grid item xs={6}>
                      <TextField
                        id="boxaddress_line_1"
                        label={t("Report.Schedule.Box.AddressLine1")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.boxaddress_line_1}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '42ch' }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id="boxaddress_line_2"
                        label={t("Report.Schedule.Box.AddressLine2")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.boxaddress_line_2}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '42ch' }}
                      />
                    </Grid>

                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={4}>
                      <TextField
                        id="boxcity"
                        label={t("Report.Schedule.Box.City")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.boxcity}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '27ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="boxstate"
                        label={t("Report.Schedule.Box.State")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.boxstate}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '27ch' }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="boxzip"
                        label={t("Report.Schedule.Box.Zip")}
                        className={classes.textField}
                        margin="normal"
                        value={this.props.selectedObject.boxzip}
                        InputProps={{
                          readOnly: true,
                          autocomplete: 'new-password',
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        variant="standard"
                        sx={{ width: '27ch' }}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>

                  <Button onClick={this.handleClose} color="primary" className={classes.primaryButton} style={{ position: 'absolute', bottom: '15px' }}>
                    {t("Report.Schedule.Box.CloseButton")}
                  </Button>
                </DialogActions>
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <DialogTitle id="form-dialog-title">{t("Report.Schedule.Consult.ConsultRoom")}<span style={{ color: '#385cad', fontWeight: 500, textDecoration: 'none ', fontSize: '1.5rem' }}>{this.props.selectedObject.pucode}</span></DialogTitle>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ width: '50%' }}>
                    <DialogContent>
                      <Typography variant="title" color="inherit" noWrap className={classes.flex}> Consultation Notes</Typography>
                      <TextareaAutosize
                        style={{ minHeight: 130, maxHeight: 130, width: '100%', boxSizing: 'border-box', border: '1px solid rgba(224, 224, 224, 1)', fontSize: '0.8125rem', fontWeight: '400', padding: '10px', fontFamily: 'Roboto,Helvetica,Arial,sans-serif', color: 'rgba(0, 0, 0, 0.87)' }}
                        onBlur={this.handleChangeConsultNotes}
                        onChange={this.handleChangeConsultNotes}
                        label={t("Report.Schedule.Consult.ConsultationNotes")}
                        defaultValue={this.state.consultnotes}
                        value={this.state.consultnotes}
                      />
                    </DialogContent>
                  </div>
                  <div style={{ width: '50%' }}>
                    <DialogContent>
                      <Table className={classes.table}>
                        <TableHead className={classNames(classes.TableHead)}>
                          <TableRow>
                            <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0, color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}>
                              <b>{t("Report.Schedule.Consult.RxHash")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0, color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}>
                              <b>{t("Report.Schedule.Consult.DrugName")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0, color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}>
                              <b>{t("Report.Schedule.Consult.Dose")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0, color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}>
                              <b>{t("Report.Schedule.Consult.Qty")}</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.createRow()}
                        </TableBody>
                      </Table>
                    </DialogContent>
                  </div>
                </div>
                <div>
                  <DialogContent>
                    <div>
                      <FormControlLabel
                        label={t("Report.Schedule.Consult.ReleaseOrderCheckBox")}
                        control={
                          <Checkbox
                            disabled={this.state.ReleaseOrder}
                            checked={this.state.ReleaseOrder}
                            onChange={() => this.handleReleaseOrder('')}
                            value={this.state.ReleaseOrder}
                          />
                        }
                        style={{ marginLeft: '0px', marginRight: '0px' }}
                      />
                    </div>
                  </DialogContent>
                </div>
                <DialogActions>
                  <Button
                    type="submit"
                    disabled={this.state.isButtonDisabled}
                    color="primary"
                    onClick={this.state.ReleaseOrder ? () => this.savemanualuserConsult(true) : () => this.setState({ orderNotReleasedOpen: true })}
                    className={classes.primaryButton}>
                    {t("Report.Schedule.Consult.CompleteConsultButton")}
                  </Button>
                  <Button onClick={this.handleClose} color="primary" className={classes.primaryButton}>
                    {t("Report.Schedule.Consult.CloseButton")}
                  </Button>
                </DialogActions>
              </div>
            </TabContainer>
          </SwipeableViews>
        </Dialog>
        <Dialog
          open={this.state.ReleaseOrderOpen}
          onClose={this.handleCloseRleaseOrder}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className={classes.DialogBack} style={{ background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)' }}>
            <DialogContent>
              <DialogContentText className={classes.DialogText} style={{ color: '#387371', textAlign: 'center' }}>
                {t("Report.Schedule.Consult.ReleaseOrder.AreYouSureToReleaseOrder")}
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign} style={{ justifyContent: 'center' }}>
              <Button
                className={classes.buttonFace}
                style={{ color: '#387371' }}
                onClick={this.releaseorderaccept}>
                {t("Report.Schedule.Consult.ReleaseOrder.Yes")}
              </Button>
              <Button
                disabled={this.state.isButtonDisabled}
                style={{ color: '#387371' }}
                className={classes.buttonFace}
                onClick={this.handleCloseRleaseOrder}>
                {t("Report.Schedule.Consult.ReleaseOrder.No")}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        <Dialog
          open={this.state.orderNotReleasedOpen}
          onClose={this.handleConsultClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'>
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t("Report.Schedule.Consult.ConfirmRelease.YouHaveNotReleaseOrderYet")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.primaryButton}
              onClick={this.releaseorderaccept}>
              {t("Report.Schedule.Consult.ConfirmRelease..ReleaseOrder")}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.primaryButton}
              onClick={() => this.savemanualuserConsult(false)}>
              {t("Report.Schedule.Consult.ConfirmRelease.CompleteConsult")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
PatientManulOverride.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles, { withTheme: true })(withTranslation()(PatientManulOverride));



// WEBPACK FOOTER //
// ./src/components/common/schedule-consultation.js